import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';
import { InvestorContactsCellRenderer } from './InvestorContactsCellRenderer';

export const investorContactsColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'investorContactsCount',
  headerName: 'Investor Contacts Count',
  type: ['numericColumn', 'number'],
  filter: 'agNumberColumnFilter',
  cellRenderer: InvestorContactsCellRenderer,
};
